import React, { useState } from 'react';
import { financeiroPeriodoSchema } from '../../validation/financeiroPeriodoSchema';
import type { PeriodoFinanceiro } from '../../types/financeiro';

// Puramente apresentacional — nenhum import de service, nenhum hook de leitura do Apollo,
// nenhum fetch (ai/architecture.core.md §5). Controle de período: dois inputs type="date" (que já emitem
// YYYY-MM-DD nativamente), validados por financeiroPeriodoSchema. A validação roda a cada
// alteração de campo (feedback imediato), mas o commit para o pai (onChange) só acontece via
// ação explícita "Aplicar período" — nunca em erro, e nunca por keystroke isolado, para que uma
// combinação intermediária ainda válida (ex.: só o campo início mudou) não dispare sozinha uma
// nova consulta.

export interface FiltroPeriodoProps {
  periodo: PeriodoFinanceiro;
  onChange: (periodo: PeriodoFinanceiro) => void;
}

function validar(candidato: { inicio: string; fim: string }): string | null {
  const resultado = financeiroPeriodoSchema.safeParse(candidato);
  if (resultado.success) return null;
  return resultado.error.issues[0]?.message ?? 'Período inválido';
}

const FiltroPeriodo: React.FC<FiltroPeriodoProps> = ({ periodo, onChange }) => {
  const [inicio, setInicio] = useState(periodo.inicio);
  const [fim, setFim] = useState(periodo.fim);
  const [erro, setErro] = useState<string | null>(null);

  const handleInicioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const novoInicio = event.target.value;
    setInicio(novoInicio);
    setErro(validar({ inicio: novoInicio, fim }));
  };

  const handleFimChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const novoFim = event.target.value;
    setFim(novoFim);
    setErro(validar({ inicio, fim: novoFim }));
  };

  const handleAplicar = () => {
    const mensagem = validar({ inicio, fim });
    if (mensagem) {
      setErro(mensagem);
      return;
    }
    setErro(null);
    onChange({ inicio, fim });
  };

  return (
    <div className="d-flex flex-wrap align-items-end gap-2 mb-3" data-testid="filtro-periodo">
      <div>
        <label htmlFor="financeiro-filtro-inicio" className="form-label font-xsss fw-600 d-block mb-1">
          Início
        </label>
        <input
          id="financeiro-filtro-inicio"
          type="date"
          className="form-control"
          value={inicio}
          onChange={handleInicioChange}
        />
      </div>
      <div>
        <label htmlFor="financeiro-filtro-fim" className="form-label font-xsss fw-600 d-block mb-1">
          Fim
        </label>
        <input
          id="financeiro-filtro-fim"
          type="date"
          className="form-control"
          value={fim}
          onChange={handleFimChange}
        />
      </div>
      <button type="button" className="btn btn-primary" onClick={handleAplicar}>
        Aplicar período
      </button>
      {erro && (
        <div className="text-danger small w-100" role="alert">
          {erro}
        </div>
      )}
    </div>
  );
};

export default FiltroPeriodo;
